import axios from 'axios';
import {
    interceptorsResponseSuccess,
    interceptorsResponseError,
} from 'core/api/interceptorsResponse';
import { interceptorsRequestSuccess, interceptorsRequestError } from 'core/api/interceptorsRequest';
import { API_MICROSERVICES_URL } from '../../config';
import qs from 'qs';
import { pickBy } from 'lodash';

export const CancelToken = axios.CancelToken;
export const isCancel = axios.isCancel;

export const configRetryRefresh = {
    max: 40,
    count: 0,
};

export const baseApi = axios.create({
    baseURL: API_MICROSERVICES_URL,
});

baseApi.defaults.paramsSerializer = (params) => {
    return qs.stringify(
        pickBy(params, (value) => {
            return value !== '' && value !== null;
        })
    );
};

baseApi.interceptors.request.use(interceptorsRequestSuccess, interceptorsRequestError);
baseApi.interceptors.response.use(interceptorsResponseSuccess, interceptorsResponseError);
